export default __webpack_public_path__ + "static/media/6.82d9b549.png";